import { useState, useEffect } from "react";
import { apiFetch } from "@/lib/api-client";
import { useActiveTenantModule } from "@/hooks/use-active-tenant-module";

interface OverdueCountResponse {
  count: number;
}

/**
 * Fetch overdue CRM task count for sidebar badge.
 *
 * Polls overdue task count via api-crm gateway.
 */
export function useOverdueTaskCount() {
  const [data, setData] = useState<OverdueCountResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const crmModule = useActiveTenantModule("crm");

  useEffect(() => {
    if (crmModule.isLoading) {
      return;
    }

    if (!crmModule.isEnabled) {
      setData({ count: 0 });
      setIsLoading(false);
      return;
    }

    const promise = apiFetch<{ data: OverdueCountResponse }>("/crm/polling/tasks/overdue-count");

    promise
      .then((res) => setData(res.data))
      .catch(() => setData({ count: 0 }))
      .finally(() => setIsLoading(false));
  }, [crmModule.isEnabled, crmModule.isLoading]);

  return { overdueCount: data?.count ?? 0, isLoading };
}
